import { graphql } from "relay-runtime";
import { readFragment } from "relay-runtime/lib/store/ResolverFragments";
import { clientResolversAvailableServicesFragment$key } from "./__generated__/clientResolversAvailableServicesFragment.graphql";
import { clientResolversOutOfStockFragment$key } from "./__generated__/clientResolversOutOfStockFragment.graphql";

/**
 * @RelayResolver Hub.availableServices: [String!]
 * @rootFragment clientResolversAvailableServicesFragment
 */
export function availableServices(fragmentKey: clientResolversAvailableServicesFragment$key): string[] {
	const { slug, meta } = readFragment(
		graphql`
			fragment clientResolversAvailableServicesFragment on Hub {
				slug
				meta {
					services
				}
			}
		`,
		fragmentKey
	);

	// Convert service enums to lowercase slugs
	const serviceMap: Record<string, string> = {
		INSTANT_BUY: "instant-buy",
		ONEDELIVERY: "one-delivery",
		CLICK_N_COLLECT: "click-and-collect",
		SHOP_N_COLLECT: "shop-and-collect",
		RAFFLE: "raffle",
		LOCK_B2B: "lock",
		LOCK_B2C: "lock",
	};

	if (meta?.services) {
		return meta.services.map((service) => serviceMap[service]).filter((service): service is string => Boolean(service));
	}

	// Fallback for hubs without meta
	if (slug !== "hubby-virtual") {
		return ["instant-buy", "one-delivery", "click-and-collect"];
	}
	return ["instant-buy"];
}

/**
 * @RelayResolver HubProduct.outOfStock: Boolean
 * @rootFragment clientResolversOutOfStockFragment
 */
export function outOfStock(fragmentKey: clientResolversOutOfStockFragment$key): boolean {
	const { stock } = readFragment(
		graphql`
			fragment clientResolversOutOfStockFragment on HubProduct {
				stock
			}
		`,
		fragmentKey
	);
	return stock === 0;
}
